const { setSnackbar } = require("redux/actions/search/searchActions");

export const errorCatcherMiddleware = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    console.error("Error capturado en middleware:", err);

    // Evitar posibles loops infinitos
    if (action?.type !== "SET_SNACKBAR") {
      store.dispatch(setSnackbar("Error interno al ejecutar acción."));
    }

    return err; // no re-throw para evitar romper app
  }
};
